import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { iconAttributes } from '@/utils/icons';


export default /*@__PURE__*/_defineComponent({
  __name: 'Play',
  setup(__props) {

const attrs = iconAttributes({ width: 73, height: 88 });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _normalizeProps(_guardReactiveProps(_unref(attrs))), _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M6.96774 0.856757C4.30399 -0.819145 0.837646 1.09532 0.837646 4.24242V83.7576C0.837646 86.9047 4.30399 88.8191 6.96774 87.1432L70.1601 47.3857C72.6533 45.8171 72.6533 42.1829 70.1601 40.6143L6.96774 0.856757Z",
      fill: "currentColor"
    }, null, -1)
  ]), 16))
}
}

})